import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faArrowUp } from '@fortawesome/free-solid-svg-icons'

const KBFooter = () => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <footer className="kb-footer">
            <div className="kb-footer__content">
                <div className="kb-footer__left">
                    <p>
                        Made with{' '}
                        <FontAwesomeIcon
                            icon={faHeart}
                            className="kb-footer__heart"
                        />{' '}
                        for our team
                    </p>
                    <p className="kb-footer__note">
                        Can't find what you need? Contact your administrator
                        for assistance.
                    </p>
                </div>
                <button
                    className="kb-footer__top-btn"
                    onClick={scrollToTop}
                    title="Back to top"
                >
                    <FontAwesomeIcon icon={faArrowUp} />
                </button>
            </div>
        </footer>
    )
}

export default KBFooter
